module.exports = __webpack_public_path__ + "static/media/athletics.8491e5d0.svg";